import { HoldbackPaymentBatchedSettingsFrequency, DayOfWeek, OrdinalHoldbackPaymentSettings, DayNames } from 'types';

export function getHoldbackScheduleLabel(
  frequency: HoldbackPaymentBatchedSettingsFrequency,
  day: DayOfWeek,
  occurrences: number[],
): string {
  const dayName = DayNames[day] ?? 'Day';

  // Special case for fourtimes frequency
  if (frequency === HoldbackPaymentBatchedSettingsFrequency.fourTimes) {
    return `on ${dayName}s (5th ${dayName} excluded)`;
  }

  // Map occurrences to ordinals
  const holdbackPaymentLabels = occurrences.map((n) => OrdinalHoldbackPaymentSettings[n]).filter(Boolean);

  const ordinals =
    holdbackPaymentLabels.length === 0
      ? ''
      : holdbackPaymentLabels.length === 1
        ? holdbackPaymentLabels[0]
        : // format list with commas and 'and' before last item
          `${holdbackPaymentLabels.slice(0, -1).join(', ')}${holdbackPaymentLabels.length > 2 ? ',' : ''} and ${holdbackPaymentLabels[holdbackPaymentLabels.length - 1]}`;

  // Determine pluralization
  const plural = frequency > HoldbackPaymentBatchedSettingsFrequency.oneTime ? 's' : '';

  return `${ordinals ? ordinals + ' ' : ''}${dayName}${plural}`.trim();
}

export default getHoldbackScheduleLabel;
